import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { FileText, ArrowRight, Home, Sprout, Leaf, BookOpen } from 'lucide-react';
const VIDEOS = [{
  title: 'Acuerdos de conservación en el territorio',
  src: 'https://play.gumlet.io/embed/6a351808ba0085952b28938e'
}, {
  title: 'El trabajo junto a las comunidades del PNN Paramillo',
  src: 'https://play.gumlet.io/embed/6a3518665c94624b773e920e'
}];
const HORIZONTAL_VIDEO = {
  title: 'Resultados de los acuerdos de conservación',
  src: 'https://play.gumlet.io/embed/6a35197f5c94624b773eb4c2'
};
const VERTICAL_VIDEOS = [{
  title: 'Voces del territorio',
  src: 'https://play.gumlet.io/embed/6a35197f83334b304cb8fc9d'
}, {
  title: 'Conservación en marcha',
  src: 'https://play.gumlet.io/embed/6a35197f83334b304cb8fc99'
}];
const BOLETINES = [{
  label: 'Boletín 1',
  href: 'https://programatefos.com/wp-content/uploads/2026/06/BOLETIN_1_ACUERDOS_C5.pdf'
}, {
  label: 'Boletín 2',
  href: 'https://programatefos.com/wp-content/uploads/2026/06/BOLETIN_2_ACUERDOS_C5.pdf'
}, {
  label: 'Boletín 3',
  href: 'https://programatefos.com/wp-content/uploads/2026/06/BOLETIN_3_ACUERDOS_C5.pdf'
}, {
  label: 'Boletín 4',
  href: 'https://programatefos.com/wp-content/uploads/2026/06/BOLETIN_4_ACUERDOS_C5.pdf'
}, {
  label: 'Boletín 5',
  href: 'https://programatefos.com/wp-content/uploads/2026/06/BOLETIN_5_ACUERDOS_C5.pdf'
}, {
  label: 'Boletín 6',
  href: 'https://programatefos.com/wp-content/uploads/2026/06/BOLETIN_6_ACUERDOS_C5.pdf'
}];
const ACTIONS = [{
  icon: Home,
  label: 'Mejoramiento de viviendas rurales'
}, {
  icon: Sprout,
  label: 'Sistemas agroforestales de cacao'
}, {
  icon: Leaf,
  label: 'Restauración ecológica con especies nativas'
}, {
  icon: BookOpen,
  label: 'Educación ambiental en Uré y Saiza'
}];
export function AcuerdosPNN() {
  return <section id="hito-3" className="py-24 md:py-32 px-4 md:px-8 bg-bone-dark scroll-mt-24" data-id="element-15">
      <div className="max-w-[1400px] mx-auto" data-id="element-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-17">
          <div className="lg:col-span-5" data-id="element-18">
            <span className="block text-clay uppercase tracking-[0.2em] text-xs font-semibold mb-5" data-id="element-19">
              Hito 03 · Acuerdos con PNN
            </span>
            <h2 className="text-4xl md:text-5xl font-serif text-forest leading-[1.05]" data-id="element-20">
              Acuerdos de conservación en el PNN Paramillo
            </h2>
            <p className="text-lg text-charcoal/70 font-light leading-relaxed mt-5" data-id="element-21">
              Seguimos avanzando en la consolidación de los acuerdos de
              conservación en el PNN Paramillo
            </p>
          </div>
          <div className="lg:col-span-7 lg:pt-3 space-y-5 text-charcoal/80 font-light leading-relaxed" data-id="element-22">
            <p className="text-lg md:text-xl text-charcoal/85" data-id="element-23">
              Desde 2023, en el marco del Proyecto TEFOS, Parques Nacionales
              Naturales de Colombia ha venido suscribiendo acuerdos de
              conservación, de gestión y metodológicos con familias campesinas
              vulnerables del PNN Paramillo.
            </p>
            <p data-id="element-24">
              Estos acuerdos buscan armonizar los derechos del ambiente y del
              campesinado, contribuyendo a la conservación y el manejo
              sostenible de la biodiversidad, así como a la reducción de la
              deforestación en el área protegida. Mediante estos compromisos,
              las familias acuerdan no realizar actividades como tala, cacería y
              quema, mientras que, de manera concertada, se implementan acciones
              para mejorar su calidad de vida y fortalecer medios de vida
              sostenibles.
            </p>
          </div>
        </div>

        {/* Stats + actions panel */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 lg:grid-cols-12 gap-0 bg-forest text-bone overflow-hidden mb-16" data-id="element-25">
          <div className="lg:col-span-5 relative min-h-[320px] lg:min-h-0" data-id="element-26">
            <img src="https://cdn.magicpatterns.com/uploads/4kU1SJA6DC7TJSuGJguKjo/paramillo.jpg" alt="Río y selva en el PNN Paramillo" className="absolute inset-0 w-full h-full object-cover" data-id="element-27" />
          </div>
          <div className="lg:col-span-7 p-8 md:p-12 lg:p-14" data-id="element-28">
            <span className="text-clay-light text-xs uppercase tracking-[0.2em] font-semibold" data-id="element-29">
              Resultados a la fecha
            </span>
            <div className="grid grid-cols-2 gap-8 mt-6 mb-10 pb-10 border-b border-bone/15" data-id="element-30">
              <div data-id="element-31">
                <div className="font-serif text-clay-light text-6xl md:text-7xl leading-none" data-id="element-32">
                  195
                </div>
                <div className="text-bone/70 text-sm mt-3 font-light" data-id="element-33">
                  Acuerdos de conservación firmados
                </div>
              </div>
              <div data-id="element-34">
                <div className="font-serif text-clay-light text-6xl md:text-7xl leading-none" data-id="element-35">
                  19
                </div>
                <div className="text-bone/70 text-sm mt-3 font-light" data-id="element-36">
                  Acuerdos metodológicos firmados
                </div>
              </div>
            </div>

            <div className="text-xs uppercase tracking-[0.2em] text-bone/60 font-semibold mb-5" data-id="element-37">
              Acciones concertadas
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-38">
              {ACTIONS.map(action => {
              const Icon = action.icon;
              return <div key={action.label} className="flex items-center gap-3" data-id="element-39">
                    <Icon className="text-clay-light flex-none" size={20} strokeWidth={1.5} data-id="element-40" />
                    <span className="text-bone/90 text-sm font-light" data-id="element-41">
                      {action.label}
                    </span>
                  </div>;
            })}
            </div>
          </div>
        </motion.div>

        {/* Two windows: videos + boletines */}
        <div className="mb-2" data-id="element-42">
          <h3 className="font-serif text-2xl md:text-3xl text-forest mb-3" data-id="element-43">
            Explora los avances
          </h3>
          <p className="text-charcoal/70 font-light leading-relaxed mb-8 max-w-2xl" data-id="element-44">
            Conoce más sobre este proceso y explora los videos y documentos que
            registran los avances y resultados del trabajo junto a las
            comunidades del PNN Paramillo.
          </p>
        </div>
        {/* Videos embebidos */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-45">
          {VIDEOS.map((video, i) => <motion.figure key={video.src} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} data-id="element-46">
              <div className="relative w-full bg-charcoal overflow-hidden" style={{
            aspectRatio: '16/9'
          }} data-id="element-47">
                <iframe loading="lazy" title={video.title} src={video.src} style={{
              border: 'none',
              position: 'absolute',
              top: 0,
              left: 0,
              height: '100%',
              width: '100%'
            }} referrerPolicy="origin" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen;clipboard-write;" data-id="element-48" />
              </div>
              <figcaption className="text-charcoal/70 text-sm font-light mt-3" data-id="element-49">
                {video.title}
              </figcaption>
            </motion.figure>)}
        </div>

        {/* Horizontal video */}
        <motion.figure initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-6" data-id="element-50">
          <div className="relative w-full bg-charcoal overflow-hidden" style={{
          aspectRatio: '16/9'
        }} data-id="element-51">
            <iframe loading="lazy" title={HORIZONTAL_VIDEO.title} src={HORIZONTAL_VIDEO.src} style={{
            border: 'none',
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%'
          }} referrerPolicy="origin" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen;clipboard-write;" data-id="element-52" />
          </div>
          <figcaption className="text-charcoal/70 text-sm font-light mt-3" data-id="element-53">
            {HORIZONTAL_VIDEO.title}
          </figcaption>
        </motion.figure>

        {/* Vertical videos */}
        <div className="grid grid-cols-2 gap-6 max-w-2xl mx-auto mb-10" data-id="element-54">
          {VERTICAL_VIDEOS.map((video, i) => <motion.figure key={video.src} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} data-id="element-55">
              <div className="relative w-full bg-charcoal overflow-hidden" style={{
            aspectRatio: '9/16'
          }} data-id="element-56">
                <iframe loading="lazy" title={video.title} src={video.src} style={{
              border: 'none',
              position: 'absolute',
              top: 0,
              left: 0,
              height: '100%',
              width: '100%'
            }} referrerPolicy="origin" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen;clipboard-write;" data-id="element-57" />
              </div>
              <figcaption className="text-charcoal/70 text-sm font-light mt-3" data-id="element-58">
                {video.title}
              </figcaption>
            </motion.figure>)}
        </div>

        {/* Boletines window */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-forest text-bone p-8 md:p-10" data-id="element-59">
          <div className="flex items-center gap-5 mb-8" data-id="element-60">
            <div className="w-14 h-14 bg-clay flex items-center justify-center text-bone flex-none" data-id="element-61">
              <FileText size={24} data-id="element-62" />
            </div>
            <div data-id="element-63">
              <h4 className="font-serif text-2xl md:text-3xl leading-tight" data-id="element-64">
                Boletines
              </h4>
              <p className="text-bone/70 text-sm font-light mt-1" data-id="element-65">
                Documentos que registran los avances del proceso.
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-66">
            {BOLETINES.map(boletin => <a key={boletin.href} href={boletin.href} target="_blank" rel="noopener noreferrer" className="group flex items-center justify-between gap-3 border border-bone/20 hover:border-clay-light hover:bg-bone/5 px-5 py-4 transition-colors" data-id="element-67">
                <span className="font-medium text-bone/95" data-id="element-68">
                  {boletin.label}
                </span>
                <ArrowRight size={18} className="text-clay-light flex-none transform group-hover:translate-x-1 transition-transform" data-id="element-69" />
              </a>)}
          </div>
        </motion.div>
      </div>
    </section>;
}